import React from "react"
import * as css from "@css/projects/p-news-list.module.styl"
// import Tags from "@projects/Tags"
import { Image } from "@atoms/Image"
import { TransitionLink } from "../atoms/Link"

function NewsList({ data }) {
    // data = []
    return (
        <div className={css.pNewsList}>
            {data.length === 0 ?
                <div className={css.aEmpty}>
                    <h5 className={css.aTitle}>Empty</h5>
                    <p className={css.aText}>まだ投稿がありません。</p>
                </div>
                :
                <ul>
                    {data.map(({ node }, i) => {
                        let { date, title, uri, acf_news, databaseId } = node
                        let {category} = acf_news
                        console.log("===>", uri)
                        return (
                            <li key={i}>
                                <TransitionLink className={css.aInner} to={`/news/${databaseId}/`}>
                                    <p className={css.aDate}>{date}</p>
                                    <div className={css.aCategorys}>
                                        <span className={css.aCategory}>{category}</span>
                                    </div>
                                    <p className={css.aTitle} dangerouslySetInnerHTML={{ __html: title }}/>
                                    <div className={css.aArrow2}></div>
                                </TransitionLink>
                            </li>
                        )
                    })}
                </ul>
            }
        </div>
    )
}

export { NewsList }